
// --------------------------------------------------------------------------
// #76 - DUPLICATE FORM FIELD
//     - Allows user to duplicate a form field.
//     - [data-behavior] attribute should be attached to a tag which wraps
//       both the duplicatable field and the control.
//     - [data-behavior="duplicatable-field"] attribute should be added to
//       the containing div which should have a class of `.field-group`.
//     - [data-binding="append-to"] is used to specify which element
//       duplicate fields should be appended to.
//     - [data-binding="duplicate-field-control"] is uses to specify the link
//       or button which triggers the duplicate field.
//     - Only a single field can be duplicated.
//     - New fields are given an incremental unique id.
//     - Note: label clone currently only works on one word labels.
// --------------------------------------------------------------------------
// Author:      Thomas Jeatt
// Email:       frontend@zonedigital.com
// URL:         http://zonedigital.com
// Copyright:   Copyright (c) 2015, zonedigital.com. All rights reserved.
// Version:     1
// --------------------------------------------------------------------------

'use strict';

module.exports = function (options) {
	var context = options.context;

	var duplicateFieldControl = context.find('[data-binding="duplicate-field-control"]');
	var removeFieldControl = context.find('[data-binding="remove-duplicate-field-control"]');
	var duplicatableField = context.find('[data-binding="duplicatable-field"]');
	var appendTo = context.find('[data-binding="append-to"]');
	var counter = 0;

	function showRemoveButton() {
		if (counter > 0) {
			removeFieldControl.css('display', 'table');
		} else {
			removeFieldControl.css('display', 'none');
		}
	}

	function duplicateFormField() {
		duplicateFieldControl.on('click', function (e) {
			e.preventDefault();
			counter++;

			/// Clone field and set values
			var clonedContent = duplicatableField.clone();
			var clonedInput = clonedContent.find('input');
			var clonedLabel = clonedContent.find('label');
			var clonedInputId = clonedInput.attr('id');
			var clonedInputIdsubString = clonedInputId.split('-')[0];
			var clonedLabelText = clonedLabel.text();
			var clonedLabelTextSubString = clonedLabelText.split(' ')[0];
			var idValue = clonedInputIdsubString + '-' + counter;
			var nameValue = clonedInputIdsubString + '[' + counter + ']';
			var labelValue = clonedLabelTextSubString + ' ' + (counter + 1) + ':';

			/// Update id, name, for and label values
			clonedInput.val('').end();
			clonedInput.attr('name', nameValue);
			clonedInput.attr('id', idValue);
			clonedLabel.attr('for', idValue);
			clonedLabel.text(labelValue);

			// Remove validation 
			clonedContent.find('[data-binding="field-validation"]').remove();

			/// append the cloned content
			clonedContent.appendTo(appendTo);
			showRemoveButton();
		});
	}

	function removeLastClonedField() {
		removeFieldControl.on('click', function (e) {
			e.preventDefault();
			context.find('[data-binding="duplicatable-field"]').last().remove();
			counter--;
			showRemoveButton();
		});
	}

	function init() {
		duplicateFormField();
		removeLastClonedField();
	}

	return {
		init: init
	};
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/duplicate-form-field.js
// module id = 260
// module chunks = 0